<div class="flex flex-wrap gap-7">
    @for (chip of statusChips; track $index) {
        <app-tooltip>
            <app-chip
                trigger
                [dataQa]="dataQa.statusChipFilter"
                [defaultSelected]="isItemSelected(chip.backingField)"
                (clicked)="handleFilterSelect(chip.backingField)">
                {{ chip.name }}({{ chip.assigned }}/{{ chip.unassigned }}/{{
                    chip.total
                }})
            </app-chip>
            <div content>
                <b>{{ chip.assigned }}</b> assigned to me /
                <b>{{ chip.unassigned }}</b> unassigned /
                <b>{{ chip.total }}</b> total
            </div>
        </app-tooltip>
    }
</div>
